<div class="checkin__tooltip__container" [ngClass]="class" (mouseleave)="!canClick && toggleIsHoverTooltip()">
  <i
    *ngIf="icon"
    appear (deferLoad)="appearHandler()"
    class="{{ icon }}"
    [ngClass]="{ 'checkin__tooltip--disabled' : disabled }"
    (click)="canClick && show()"
    (mouseenter)="!canClick && toggleIsHoverTooltip()"></i>
  <div
    *ngIf="(canClick && isTooltipVisible) || (!canClick && isHoverTooltip)"
    @fadeTooltip
    class="checkin__tooltip"
    [ngClass]="[classTooltip]">
    <div class="checkin__tooltip__arrow" [ngClass]="classArrow"></div>
    <div class="checkin__tooltip__title" *ngIf="title">
      {{ title | translate }}
    </div>
    <div class="checkin__tooltip__text" [innerHTML]="text | translate:translateParams"></div>
    <div class="checkin__tooltip__button" *ngIf="closeText && canClick">
      <span (click)="hide()">{{ closeText | translate }}</span>
    </div>
  </div>
</div>
